// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"545":"34364a43","598":"52f7f6e8"}[chunkId] + ".chunk.js";
};